import {Container} from "react-bootstrap";
import {useDarkMode} from "../context";
import {useApp, useOnlineStatus, useInBrowserTab} from "../hooks";
import {IconFooter} from "./_components";
import {Link} from "react-router-dom";
import {minToVerboseTime} from "../utils2";
import {ABOverlayTooltip} from "./_components/CustomOverlayTooltip";
import React from "react";

export function FooterBootstrap() {
    const {name, version, isDebug} = useApp()
    const online = useOnlineStatus()
    const isInBrowserTab = useInBrowserTab()
    // const isInBrowserTab = false // Simulate Standalone
    const {darkMode} = useDarkMode()

    if (!isInBrowserTab) {
        return <div style={{height: "60px"}}/>
    }

    const year = new Date().getFullYear()

    return (
        <div className="position-lg-fixed bottom-0 w-100 bg-body-secondary pt-2 mt-2 mt-4">
            {/*<Container fluid="lg" className="d-flex flex-column flex-sm-row justify-content-center align-items-center text-center p-1 mb-1">*/}
            {/*<Container fluid="lg" className="d-flex flex-column flex-sm-row justify-content-start align-items-center p-1 mb-1">*/}
            <Container fluid="lg" className="d-flex flex-sm-row flex-wrap align-items-center justify-content-sm-between justify-content-start gap-3 p-1 mb-1">

                <div>
                    <div className={`fw-bold ${darkMode ? "text-white" : "text-primary"}`}>ALTRABITS</div>
                    <div className={`fw-medium ${darkMode ? "text-white" : "text-primary"}`}>Connect. Control. Stream.</div>
                    {/*<div className="">Connect. Control. Stream.</div>*/}
                    <div>{isInBrowserTab ? "Browser" : "Standalone"}</div>
                </div>

                <div>
                    <div className="fw-semibold text-uppercase">Company</div>
                    <div className="d-flex flex-column">
                        <Link to="/contact-us" className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">Contact us</Link>
                        <Link to="/git/SiteInfo/About.md" className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">About</Link>
                        <Link to="/git/Career/Careers.md" className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">Careers</Link>
                    </div>
                </div>

                <div>
                    <div className=" fw-semibold text-uppercase">Terms & Policies</div>
                    <div className="d-flex flex-column">
                        <Link to="/git/SiteInfo/TermsOfUse.md" className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">Terms of Use</Link>
                        <Link to="/git/SiteInfo/PrivacyPolicy.md" className="link-underline link-underline-opacity-0 link-underline-opacity-75-hover">Privacy
                            Policy</Link>
                    </div>
                </div>

            </Container>

            <Container fluid="lg" className="d-flex flex-wrap justify-content-between align-items-center bg-body-secondary py-0">
                <div className="small"><AppStatus name={name} debug={isDebug} version={version} online={online}/></div>
                <div className="small">© {year} Copyright AltraBits.com. All rights reserved.</div>

                {/*<div style={{fontSize: ".85rem"}}><AppStatus name={name} debug={isDebug} version={version} online={online}/></div>*/}
                {/*<div style={{fontSize: ".85rem"}}>© 2024 Copyright <a style={{textDecoration: "none"}} href="https://altrabits.com/">AltraBits.com</a></div>*/}
                {/*<div style={{fontSize: ".85rem"}}><PahoStatus/></div>*/}
            </Container>
        </div>
    )
}

export function AppStatus({name, debug, version, online}) {
    return (
        <div className="d-flex align-items-center gap-1">
            {online ?
                <ABOverlayTooltip placement="top" tip={`${name} is online`}><span className="text-secondary"><IconFooter name="cloudy"/></span></ABOverlayTooltip>
                :
                <ABOverlayTooltip placement="top" tip={`${name} is offline`}><span className="text-danger"><IconFooter name="cloud-slash"/></span></ABOverlayTooltip>
            }

            <ABOverlayTooltip placement="top" tip={`${debug ? "Debug mode." : ""} Version: ${version}`}>{name}</ABOverlayTooltip>
        </div>
    )
}
